import { buildApiUrl } from '@/global';
import { usePost } from '@/shared/hook/usePost';
import { useEffect, useRef } from 'react';

interface PingRequest {
  a: string;
  i: string;
}

interface ListPongResponse {
  ets: PongResponse[];
}

interface PongResponse {
  i: string;
  e: boolean;
}

export const QuotaHeartbeatOrchestrator = () => {
  const activeInstances = useRef(new Map<string, PingRequest>());
  const pingPost = usePost<PingRequest[], ListPongResponse>(buildApiUrl(`/Cuenta/ping`));

  useEffect(() => {
    const channel = new BroadcastChannel('heartbeat_bus');

    channel.onmessage = (event) => {
      const { type, payload } = event.data as { type: string; payload: PingRequest };
      if (type === 'HEARTBEAT_TICK') {
        activeInstances.current.set(payload.i, payload);
      }
      if (type === 'INSTANCE_CLOSED') {
        activeInstances.current.delete(payload.i);
      }
    };

    // EL ENVÍO EN LOTES (The Batching)
    const sendBatch = async () => {
      if (activeInstances.current.size === 0) return;

      // // Convertimos el Mapa en una LISTA para el cuerpo de la solicitud
      const batchPayload = Array.from(activeInstances.current.values());

      try {
        await pingPost.postData(batchPayload, { throwOnError: true });

        if (pingPost.data?.ets) {
          pingPost.data.ets.forEach((pong) => {
            if (pong.e === false) {
              activeInstances.current.delete(pong.i);
            }
          });
        }
      } catch (err: unknown) {
        console.error((err as Error)?.message || '');
      }
    };

    const batchInterval = setInterval(sendBatch, 1000 * 60 * 5);
    return () => {
      clearInterval(batchInterval);
      channel.close();
    };
  }, []);

  return null;
};
